import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { ApiDetailFsResponse, ApiExploreFsResponse } from './api-fast-sint.model';
import { FastSintTransformer } from './api-fast-sint.transformer';

import { HttpRequestsService, RequestParams } from '@core/services/http-requests/http-requests.service';
import { DetailFsResponse, ExploreFsResponse } from '@shared/fast-sint/models/fast-sint.models';

@Injectable()
export class ApiFastSintService {
    constructor(private readonly http: HttpClient, private readonly requestService: HttpRequestsService) {}

    public apiExploreFs(
        storeId: string,
        languageId: string,
        orderId: number,
        params?: RequestParams,
    ): Observable<ExploreFsResponse> {
        const slug = `order/store/${storeId}/order/${orderId}/explorefs`;

        const url = this.requestService.requestUrl(slug, languageId, params, true, '4', 'itxrest');

        const options = {
            withCredentials: true,
        };

        return this.http
            .get<ApiExploreFsResponse>(url, options)
            .pipe(
                map((data) => FastSintTransformer.ExploreFromApi(data)),
                catchError((_error) => {
                    return of({ isFastSint: false });
                })
            );
    }

    public apiDetailFs(
        storeId: string,
        languageId: string,
        orderId: number,
        params?: RequestParams,
    ): Observable<DetailFsResponse> {
        const slug = `order/store/${storeId}/order/${orderId}/detailfs`;

        const url = this.requestService.requestUrl(slug, languageId, params, true, '4', 'itxrest');

        const options = {
            withCredentials: true,
        };

        return this.http
            .get<ApiDetailFsResponse>(url, options)
            .pipe(
                map((data) => FastSintTransformer.DetailFromApi(data)),
                catchError((_error) => {
                    return of({ isFastSint: false, physicalStoresList: [] });
                })
            );
    }
}
